import { memo } from "react";
import { Text, View, Page, Document, PDFViewer } from "@react-pdf/renderer";
import styles from "../pdf/Styles.js";
import "../pdf/Fonts.js";

const InfoBox = ({ title, data }) => {
    return (
        <View style={{ marginTop: 30, padding: 10, border: '1px solid #000' }}>
            <Text
                style={{
                    fontSize: 22,
                    fontWeight: 'bold',
                    marginBottom: 10,
                    textAlign: "center"
                }}
            >
                {title}
            </Text>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                {data.map((column, columnIndex) => (
                    <View key={columnIndex} style={{ flexDirection: 'column', width: '30%' }}>
                        {column.map((item, rowIndex) => (
                            <View key={rowIndex} style={{ flexDirection: 'row', marginBottom: 5, justifyContent: 'space-between' }}>
                                <Text style={{ fontWeight: 'bold', fontSize: 14 }}>{item.key}: </Text>
                                <Text style={{ fontSize: 14 }}>{item.value}</Text>
                            </View>
                        ))}
                    </View>
                ))}
            </View>
        </View>
    );
};

const ParentInfoBox = ({ motherTitle, fatherTitle, motherData, fatherData, motherContextNote, fatherContextNote }) => {
    return (
        <View style={{ marginTop: 30, padding: 10, border: '1px solid #000' }}>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 10 }}>
                <Text style={{ fontSize: 22, fontWeight: 'bold', width: '48%', textAlign: 'center' }}>
                    {motherTitle}
                </Text>
                <Text style={{ fontSize: 22, fontWeight: 'bold', width: '48%', textAlign: 'center' }}>
                    {fatherTitle}
                </Text>
            </View>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                <View style={{ flexDirection: 'column', width: '48%' }}>
                    {motherData.map((item, index) => (
                        <View key={index} style={{ flexDirection: 'row', marginBottom: 5, justifyContent: 'space-between' }}>
                            <Text style={{ fontWeight: 'bold', fontSize: 14 }}>{item.key}: </Text>
                            <Text style={{ fontSize: 14 }}>{item.value}</Text>
                        </View>
                    ))}
                    {motherContextNote && (
                        <Text style={{ fontSize: 11, marginTop: 5, color: '#555' }}>
                            {motherContextNote}
                        </Text>
                    )}
                </View>
                <View style={{ flexDirection: 'column', width: '48%' }}>
                    {fatherData.map((item, index) => (
                        <View key={index} style={{ flexDirection: 'row', marginBottom: 5, justifyContent: 'space-between' }}>
                            <Text style={{ fontWeight: 'bold', fontSize: 14 }}>{item.key}: </Text>
                            <Text style={{ fontSize: 14 }}>{item.value}</Text>
                        </View>
                    ))}
                    {fatherContextNote && (
                        <Text style={{ fontSize: 11, marginTop: 5, color: '#555' }}>
                            {fatherContextNote}
                        </Text>
                    )}
                </View>
            </View>
        </View>
    );
};

const MilkingDataBox = ({ title, motherMilkingData }) => {
    return (
        <View style={{ marginTop: 30, padding: 10, border: '1px solid #000' }}>
            <Text
                style={{
                    fontSize: 22,
                    fontWeight: 'bold',
                    marginBottom: 10,
                    textAlign: "center"
                }}
            >
                {title}
            </Text>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
                <Text style={{ fontWeight: 'bold', fontSize: 14, flex: 1, textAlign: 'center' }}>Αριθμός Γαλακτικών Περιόδων</Text>
                <Text style={{ fontWeight: 'bold', fontSize: 14, flex: 1, textAlign: 'center' }}>Γαλακτοπαραγωγή (χγρ)</Text>
                <Text style={{ fontWeight: 'bold', fontSize: 14, flex: 1, textAlign: 'center' }}>Διάρκεια (ημέρες)</Text>
                <Text style={{ fontWeight: 'bold', fontSize: 14, flex: 1, textAlign: 'center' }}>Πολυδυμία</Text>
            </View>
            {motherMilkingData?.map((data, index) => (
                <View key={index} style={{ flexDirection: 'row', marginBottom: 5, justifyContent: 'space-between', width: '100%' }}>
                    <Text style={{ fontSize: 14, flex: 1, textAlign: 'center' }}>{index + 1}</Text>
                    <Text style={{ fontSize: 14, flex: 1, textAlign: 'center' }}>{data.milkProduction}</Text>
                    <Text style={{ fontSize: 14, flex: 1, textAlign: 'center' }}>{data.duration?.toFixed(2)}</Text>
                    <Text style={{ fontSize: 14, flex: 1, textAlign: 'center' }}>{data.prolificacy}</Text>
                </View>
            ))}
        </View>
    );
};

const SignatureSection = ({ kentroName, organization }) => {
    // Special case for organization orgId === "2"
    if (organization?.orgId === "2") {
        return (
            <View style={{
                marginTop: 50,
                paddingTop: 20,
            }}>
                <View style={{
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    paddingTop: 20,
                    paddingLeft: 30,
                    borderTop: '1px solid #ccc',
                }}>
                    <View style={{
                        alignItems: 'center',
                    }}>
                        <Text style={{ fontSize: 14, fontWeight: 'bold', marginBottom: 8, textAlign: 'center' }}>
                            Η ΕΚΤΡΟΦΗ ΑΝΗΚΕΙ ΣΤΟΝ
                        </Text>
                        <Text style={{ fontSize: 14, fontWeight: 'bold', marginBottom: 8, textAlign: 'center' }}>
                            {organization?.name}
                        </Text>
                        <View style={{
                            minWidth: 180,
                            height: 60,
                        }} />
                    </View>
                </View>
            </View>
        );
    }

    // Default case for other organizations
    return (
        <View style={{
            marginTop: 50,
            paddingTop: 20,
        }}>
            {/* Three signature spots footer */}
            <View style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                paddingTop: 20,
                borderTop: '1px solid #ccc',
            }}>
                {/* Left: Φορέας */}
                <View style={{
                    width: '40%',
                    alignItems: 'center',
                }}>
                    <Text style={{ fontSize: 14, fontWeight: 'bold', marginBottom: 8, textAlign: 'center' }}>
                        {organization?.orgId === "1" ? 'ΑΓΡΟΤΙΚΟΣ ΣΥΝΕΤΑΙΡΙΣΜΟΣ ΠΡΟΒΑΤΟΤΡΟΦΩΝ ΦΥΛΗΣ ΧΙΟΥ "ΜΑΚΕΔΟΝΙΑ"' : organization?.name}
                    </Text>
                    <View style={{
                        minWidth: 180,
                        height: 60,
                    }} />
                </View>

                {/* Right: Κ.Γ.Β.Ζ. */}
                <View style={{
                    flex: 1,
                    alignItems: 'center',
                }}>
                    <Text style={{ fontSize: 14, fontWeight: 'bold', marginBottom: 4, textAlign: 'center' }}>
                        Εθεωρήθη
                    </Text>
                    {kentroName && (
                        <Text style={{ fontSize: 14, fontWeight: 'bold', marginBottom: 8, textAlign: 'center' }}>
                            Κ.Ζ.Γ.Π. {kentroName}
                        </Text>
                    )}
                    <View style={{
                        minWidth: 180,
                        height: 60,
                    }} />
                </View>
            </View>
        </View>
    );
};

// ============================================================
// Helper functions (shared between both components)
// ============================================================

const formatToTwoDecimals = (value) => {
    return value ? parseFloat(value).toFixed(2) : "";
};

const formatInteger = (value) => {
    if (value == null) return "";
    return Math.round(value).toString();
};

/**
 * Build context note for female animals (mothers, grandmothers)
 * Matches old system format - distinguishes between completed and ongoing periods
 */
const buildFemaleContextNote = (completedPeriodsCount, ongoingPeriodsCount) => {
    if (completedPeriodsCount && completedPeriodsCount > 0) {
        if (ongoingPeriodsCount && ongoingPeriodsCount > 0) {
            // Has both completed and ongoing
            if (completedPeriodsCount === 1) {
                return `[Με βάση στοιχεία από 1 ολοκληρωμένη και την τρέχουσα γαλακτική περίοδο]`;
            }
            return `[Με βάση στοιχεία από ${completedPeriodsCount} ολοκληρωμένες και την τρέχουσα γαλακτική περίοδο]`;
        }
        // Only completed periods
        if (completedPeriodsCount === 1) {
            return `[Με βάση στοιχεία από 1 ολοκληρωμένη γαλακτική περίοδο]`;
        }
        return `[Με βάση στοιχεία από ${completedPeriodsCount} ολοκληρωμένες γαλακτικές περιόδους]`;
    }
    return null;
};

/**
 * Build context note for male animals (fathers, grandfathers)
 */
const buildMaleContextNote = (daughtersWithData) => {
    if (daughtersWithData && daughtersWithData > 0) {
        return `[Με βάση στοιχεία από ${daughtersWithData} θυγατέρες με ολοκληρωμένες γαλακτικές περιόδους]`;
    }
    return null;
};

// ============================================================
// Shared page renderer (used by both components)
// ============================================================

const renderAnimalPage = (animalEntry, selectedOwner) => {
    const data = animalEntry.data || {};

    const animalData = [
        [
            { key: "Αριθμός Ενωτίου", value: data?.animal?.flockCode },
            { key: "Αριθμός Γενεαλογικού Βιβλίου", value: data?.animal?.registrationCode },
            { key: "Βάρος Γέννησης", value: data?.animal?.birthWeight || "" }
        ],
        [
            { key: "Φυλή", value: data?.animal?.breedCode },
            { key: "Βάρος Απογαλακτισμού", value: data?.animal?.weaningWeight || "" }
        ],
        [
            { key: "Ημερομηνία Γέννησης", value: data?.animal?.birthDate ? new Date(data?.animal?.birthDate).toLocaleDateString("el-GR") : "" },
            { key: "Φύλο", value: data?.animal?.sex },
            { key: "Γενετική Αξία", value: data?.animal?.geneticMetric || "" }
        ]
    ];

    // Mother info (female - shows Avg/Max)
    const motherInfo = [
        { key: "Κωδικός Παραγωγού", value: data?.motherOwnerCode },
        { key: "Αριθμός Ενωτίου", value: data?.motherData?.animalMother?.flockCode },
        { key: "Αριθμός Γενεαλογικού Βιβλίου", value: data?.motherData?.animalMother?.registrationCode },
        { key: "Συν. Γαλακτοπαραγωγή (Μ.Ο./Μέγ.)", value: `${formatToTwoDecimals(data?.motherData?.averageMilkProduction)}/${formatToTwoDecimals(data?.motherData?.maxMilkProduction)}` },
        { key: "Μέρες Στην Γαλακτοπαραγωγή (Μ.Ο./Μέγ.)", value: `${formatInteger(data?.motherData?.averageMilkingDuration)}/${formatInteger(data?.motherData?.maxMilkingDuration)}` },
        { key: "Πολυδυμία (Μ.Ο./Μέγ.)", value: `${formatToTwoDecimals(data?.motherData?.averageProlificacy)}/${formatToTwoDecimals(data?.motherData?.maxProlificacy)}` },
    ];
    const motherContextNote = buildFemaleContextNote(
        data?.motherData?.completedPeriodsCount,
        data?.motherData?.ongoingPeriodsCount
    );

    // Father info (male - shows only Avg to match old system)
    const fatherInfo = [
        { key: "Κωδικός Παραγωγού", value: data?.fatherOwnerCode },
        { key: "Αριθμός Ενωτίου", value: data?.fatherData?.animalFather?.flockCode },
        { key: "Αριθμός Γενεαλογικού Βιβλίου", value: data?.fatherData?.animalFather?.registrationCode },
        { key: "Συν. Γαλακτοπαραγωγή Θυγατέρων (Μ.Ο.)", value: formatToTwoDecimals(data?.fatherData?.avgFatherDaughterMilkProduction) },
        { key: "Μέρες Στην Γαλακτοπαραγωγή Θυγατέρων (Μ.Ο.)", value: formatToTwoDecimals(data?.fatherData?.avgFatherDaughterMilkingDuration) },
        { key: "Πολυδυμία Θυγατέρων (Μ.Ο.)", value: formatToTwoDecimals(data?.fatherData?.avgFatherDaughterProlificacy) },
    ];
    const fatherContextNote = buildMaleContextNote(data?.fatherData?.daughtersWithData);

    // Mother's Mother info (female - shows Avg/Max)
    const motherMotherInfo = [
        { key: "Κωδικός Παραγωγού", value: data?.motherMotherOwnerCode },
        { key: "Αριθμός Ενωτίου", value: data?.motherMotherData?.animalMotherMother?.flockCode },
        { key: "Αριθμός Γενεαλογικού Βιβλίου", value: data?.motherMotherData?.animalMotherMother?.registrationCode },
        { key: "Συν. Γαλακτοπαραγωγή (Μ.Ο./Μέγ.)", value: `${formatToTwoDecimals(data?.motherMotherData?.averageMilkProduction)}/${formatToTwoDecimals(data?.motherMotherData?.maxMilkProduction)}` },
        { key: "Μέρες Στην Γαλακτοπαραγωγή (Μ.Ο./Μέγ.)", value: `${formatInteger(data?.motherMotherData?.averageMilkingDuration)}/${formatInteger(data?.motherMotherData?.maxMilkingDuration)}` },
        { key: "Πολυδυμία (Μ.Ο./Μέγ.)", value: `${formatToTwoDecimals(data?.motherMotherData?.averageProlificacy)}/${formatToTwoDecimals(data?.motherMotherData?.maxProlificacy)}` },
    ];
    const motherMotherContextNote = buildFemaleContextNote(
        data?.motherMotherData?.completedPeriodsCount,
        data?.motherMotherData?.ongoingPeriodsCount
    );

    // Mother's Father info (male - shows only Avg)
    const motherFatherInfo = [
        { key: "Κωδικός Παραγωγού", value: data?.motherFatherOwnerCode },
        { key: "Αριθμός Ενωτίου", value: data?.motherFatherData?.animalMotherFather?.flockCode },
        { key: "Αριθμός Γενεαλογικού Βιβλίου", value: data?.motherFatherData?.animalMotherFather?.registrationCode },
        { key: "Συν. Γαλακτοπαραγωγή Θυγατέρων (Μ.Ο.)", value: formatToTwoDecimals(data?.motherFatherData?.avgDaughterMilkProduction) },
        { key: "Μέρες Στην Γαλακτοπαραγωγή Θυγατέρων (Μ.Ο.)", value: formatToTwoDecimals(data?.motherFatherData?.avgDaughterMilkingDuration) },
        { key: "Πολυδυμία Θυγατέρων (Μ.Ο.)", value: formatToTwoDecimals(data?.motherFatherData?.avgDaughterProlificacy) },
    ];
    const motherFatherContextNote = buildMaleContextNote(data?.motherFatherData?.daughtersWithData);

    // Father's Mother info (female - shows Avg/Max)
    const fatherMotherInfo = [
        { key: "Κωδικός Παραγωγού", value: data?.fatherMotherOwnerCode },
        { key: "Αριθμός Ενωτίου", value: data?.fatherMotherData?.animalFatherMother?.flockCode },
        { key: "Αριθμός Γενεαλογικού Βιβλίου", value: data?.fatherMotherData?.animalFatherMother?.registrationCode },
        { key: "Συν. Γαλακτοπαραγωγή (Μ.Ο./Μέγ.)", value: `${formatToTwoDecimals(data?.fatherMotherData?.averageMilkProduction)}/${formatToTwoDecimals(data?.fatherMotherData?.maxMilkProduction)}` },
        { key: "Μέρες Στην Γαλακτοπαραγωγή (Μ.Ο./Μέγ.)", value: `${formatInteger(data?.fatherMotherData?.averageMilkingDuration)}/${formatInteger(data?.fatherMotherData?.maxMilkingDuration)}` },
        { key: "Πολυδυμία (Μ.Ο./Μέγ.)", value: `${formatToTwoDecimals(data?.fatherMotherData?.averageProlificacy)}/${formatToTwoDecimals(data?.fatherMotherData?.maxProlificacy)}` },
    ];
    const fatherMotherContextNote = buildFemaleContextNote(
        data?.fatherMotherData?.completedPeriodsCount,
        data?.fatherMotherData?.ongoingPeriodsCount
    );

    // Father's Father info (male - shows only Avg)
    const fatherFatherInfo = [
        { key: "Κωδικός Παραγωγού", value: data?.fatherFatherOwnerCode },
        { key: "Αριθμός Ενωτίου", value: data?.fatherFatherData?.animalFatherFather?.flockCode },
        { key: "Αριθμός Γενεαλογικού Βιβλίου", value: data?.fatherFatherData?.animalFatherFather?.registrationCode },
        { key: "Συν. Γαλακτοπαραγωγή Θυγατέρων (Μ.Ο.)", value: formatToTwoDecimals(data?.fatherFatherData?.avgDaughterMilkProduction) },
        { key: "Μέρες Στην Γαλακτοπαραγωγή Θυγατέρων (Μ.Ο.)", value: formatToTwoDecimals(data?.fatherFatherData?.avgDaughterMilkingDuration) },
        { key: "Πολυδυμία Θυγατέρων (Μ.Ο.)", value: formatToTwoDecimals(data?.fatherFatherData?.avgDaughterProlificacy) },
    ];
    const fatherFatherContextNote = buildMaleContextNote(data?.fatherFatherData?.daughtersWithData);

    const motherMilkingData = data?.motherMilkingData || [];
    const personalMilkingData = data?.animalMilkingData || [];

    return (
        <Page size='A2' style={styles.page} wrap key={data?.animal?._id || Math.random()}>
            <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'space-between' }}>
                <View>
                    <View style={styles.mainHeader}>
                        <Text>{data?.animal?.sex === "Άρρεν" ? "Γενεαλογικό Πιστοποιητικό Κριού" : "Γενεαλογικό Πιστοποιητικό Προβατίνας"}</Text>
                    </View>
                    <View style={styles.familyBox}>
                        <Text>{`Κωδικός Εκτροφής: ${selectedOwner?.code}`}</Text>
                        <Text>{`Όνομα Παραγωγού: ${selectedOwner?.lastName} ${selectedOwner?.firstName}`}</Text>
                        <Text>{`Διεύθυνση: ${selectedOwner?.address}, ${selectedOwner?.postalCode} ${selectedOwner?.city}`}</Text>
                    </View>
                    <View style={styles.title}>
                        <Text>{`Οργανισμός Έκδοσης: ${data?.organization?.orgId === "2" ? "ΚΕΝΤΡΟ ΖΩΪΚΩΝ ΓΕΝΕΤΙΚΩΝ ΠΟΡΩΝ ΘΕΣΣΑΛΟΝΙΚΗΣ" : data?.organization?.name}`}</Text>
                    </View>
                    <InfoBox title="ΑΤΟΜΙΚΑ ΣΤΟΙΧΕΙΑ" data={animalData} />

                    <ParentInfoBox
                        motherTitle="Στοιχεία Μητέρας"
                        fatherTitle="Στοιχεία Πατέρα"
                        motherData={motherInfo}
                        fatherData={fatherInfo}
                        motherContextNote={motherContextNote}
                        fatherContextNote={fatherContextNote}
                    />

                    <ParentInfoBox
                        motherTitle="Στοιχεία Μητέρας Μητέρας"
                        fatherTitle="Στοιχεία Πατέρα Μητέρας"
                        motherData={motherMotherInfo}
                        fatherData={motherFatherInfo}
                        motherContextNote={motherMotherContextNote}
                        fatherContextNote={motherFatherContextNote}
                    />

                    <ParentInfoBox
                        motherTitle="Στοιχεία Μητέρας Πατέρα"
                        fatherTitle="Στοιχεία Πατέρα Πατέρα"
                        motherData={fatherMotherInfo}
                        fatherData={fatherFatherInfo}
                        motherContextNote={fatherMotherContextNote}
                        fatherContextNote={fatherFatherContextNote}
                    />

                    {motherMilkingData.length > 0 && (
                        <MilkingDataBox
                            title={"Αποδόσεις Μητέρας"}
                            motherMilkingData={motherMilkingData}
                        />
                    )}
                    {personalMilkingData.length > 0 && (
                        <MilkingDataBox
                            title={"Ατομικές Αποδόσεις"}
                            motherMilkingData={personalMilkingData}
                        />
                    )}
                </View>

                <SignatureSection kentroName={data?.organization?.kentro_id?.label} organization={data?.organization} />
            </View>
        </Page>
    );
};

// ============================================================
// Main PDF Viewer Component (default export)
// ============================================================

const AnimalRegistrationPdf = ({
    selectedOwner,
    fetchedData,
}) => {
    return (
        <PDFViewer style={{ width: '80vw', height: '100vh' }}>
            <Document>
                {fetchedData.map((animalEntry) => renderAnimalPage(animalEntry, selectedOwner))}
            </Document>
        </PDFViewer>
    );
};

// ============================================================
// Document Component for download/print (named export)
// ============================================================

export const AnimalRegistrationDocument = ({ selectedOwner, fetchedData }) => {
    return (
        <Document>
            {fetchedData.map((animalEntry) => renderAnimalPage(animalEntry, selectedOwner))}
        </Document>
    );
};

export default memo(AnimalRegistrationPdf);